export default {
    'invoice-no': 'رقم الفاتورة',
    new: 'جديد',
    delete: 'حذف',
    account: 'الحساب',
    'invoice-date': 'تاريخ الفاتورة',
    warehouse: 'المستودع',
    document: 'المستند',
    'net-invoice': 'صافي الفاتورة',
    edit: 'تعديل',
    save: 'حفظ',
    not: 'غير',
    posted: 'مُرحّلة',
    'add-invoice': 'إضافة فاتورة',
    notes: 'ملاحظات',
    create: 'إنشاء',
    cancel: 'إلغاء',

    'delete-entry': 'حذف سطر',
    'are-you-sure-you-want-to-delete-the-entry': 'هل أنت متأكد من حذف السطر؟',
    
    'delete-invoice': 'حذف الفاتورة',
    'are-you-sure-you-want-to-delete-the-invoice-that-will-delete-the-associated-bond': 'هل أنت متأكد من حذف الفاتورة سيتم حذف السند المُرتبط أيضاً؟',
    discount: 'الحسم',
    total: 'الإجمالي',

    headers: {
        no: 'الرقم',
        warehouse: 'المستودع',
        material: 'المادة',
        quantity: 'الكمية',
        count: 'العدد',
        price: 'السعر',
        'total-amount': 'صافي القيمة',
        'notes': 'الملاحظات',
        'delivery-status': 'حالة تسليم المادة'
    },

    'context-menu': {
        edit: 'تعديل',
        delete: 'حذف'
    },
    payments: 'المدفوعات',
    'total-payments': 'مجموع المدفوعات',
    'alert-message': 'رسالة تنبيه',
    'confirm-message': 'أصبح مجموع المقبوضات أكبر من الإجمالي. هل تريد المتابعة ؟',
    'total-expenses': 'مجموع المصاريف',
    'expenses': 'المصاريف'
}